import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import ImportDataModal from 'modals/ImportDataModal';

import { IMPORT_EXPORT, SHIPPING_PARTNERS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faArrowUpWideShort, faDownload } from '@fortawesome/pro-solid-svg-icons';

import DCPickupLocationForm from './DCPickupLocationForm';

const DCPickupLocationList = () => {
	const acceptedFileTypes = useMemo(() => ['.xlsx', '.xls'], []);
	const defaultSort = useMemo(() => [{ id: 'createdDate', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'id', filterType: FilterType.string, show: false },
			{
				Header: 'createdBy',
				accessor: 'createdBy',
				filterType: FilterType.string
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				showOnMobile: true,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'modifiedBy',
				accessor: 'modifiedBy',
				filterType: FilterType.multiSelection,
				show: false
			},
			{
				Header: 'modifiedDate',
				accessor: 'modifiedDate',
				filterType: FilterType.date,
				showOnMobile: true,
				renderCell: ListComponents.DATETIME,
				show: false
			},
			{
				Header: 'warehouseID',
				accessor: 'warehouseId',
				filterType: FilterType.string
			},
			{
				Header: 'branchIDNumber',
				accessor: 'branchId',
				filterType: FilterType.string
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'dcSettingsID',
				accessor: 'dcSettingsId',
				filterType: FilterType.string
			},
			{
				Header: 'dcPickupLocationId',
				accessor: 'dcPickupLocationId',
				filterType: FilterType.string
			},
			{
				Header: 'companyID',
				accessor: 'companyId',
				filterType: FilterType.string
			},

			{ Header: 'clientName', accessor: 'clientName', filterType: FilterType.multiSelection, showOnMobile: true },
			{ Header: 'clientPhone', accessor: 'clientPhone', filterType: FilterType.string },
			{ Header: 'address', accessor: 'address', filterType: FilterType.string, showOnMobile: true },

			{
				Header: 'city',
				accessor: 'city',
				filterType: FilterType.multiSelection
			},

			{
				Header: 'district',
				accessor: 'district',
				filterType: FilterType.multiSelection
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/shippingPartners-icon.json.gz"
				title="dcPickupLocation">
				<Authorization path="/modal/dc-pickup-location-import">
					<Button
						icon={faDownload}
						variant="borderless"
						label="importData"
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
						onClick={() =>
							NiceModal.show(ImportDataModal, {
								title: 'dcPickupLocationImport',
								acceptedFileTypes,
								icon: faArrowUpWideShort,
								downloadUrl: IMPORT_EXPORT.GET_DC_PICKUP_LOCATION_TEMPLATE,
								uploadUrl: IMPORT_EXPORT.IMPORT_DC_PICKUP_LOCATION
							})
						}
						className="mobile-hidden importDataButton"
					/>
				</Authorization>
				<Button
					icon={faPlus}
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
					label="addDCPickupLocation"
					onClick={() => NiceModal.show(DCPickupLocationForm)}
					variant="blue"
					className="addButton"
				/>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.DC_PICKUP_LOCATION_LIST}
				columns={columns}
				fetchUrl={SHIPPING_PARTNERS.GET_DC_PICKUP_LOCATION_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.SUPPORT}
				defaultSort={defaultSort}
				exportName="dcPickupLocation"
			/>
		</div>
	);
};

export default DCPickupLocationList;
